import { AptunoError } from '@shared/models';

export const IdentityValidationError = {
  isDniAlreadyUsedError: (error: AptunoError) => error.code === 'RESOURCE_ALREADY_EXISTS',
};
